import React from "react";

import "./Copyright.scss";

const Copyright = () => {
	const year = new Date().getFullYear();

	return (
		<span className="footer-copyright">
			© OkCupid {year}
		</span>
	);
};

export default Copyright;



// WEBPACK FOOTER //
// ./src/shared/components/Footer/Copyright.jsx